import { createUserManager } from 'redux-oidc';

const AUTHORITY_SERVER = process.env.REACT_APP_AUTHORITY_SERVER;
const redirect_uri = process.env.REACT_APP_CALLBACK_URL;

// console.log("NODE_ENV");
// console.log(process.env.NODE_ENV);
// console.log("REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID");
// console.log(process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID);
const client_id = process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID;
const userManagerConfig = {
  client_id,
  redirect_uri,
  response_type: 'id_token token',
  //post_logout_redirect_uri: "http://localhost:3000",
  scope: 'openid profile api1',
  authority: AUTHORITY_SERVER,
  // silent_redirect_uri: 'http://localhost:5100/silentRenew.html',
  // automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  // monitorSession: true
};

const userManager = createUserManager(userManagerConfig);
// console.log(userManager);
export default userManager;
